import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { useState } from "react";
import { alertsRepo } from "@/lib/repositories";
import { useAlertsFilterStore } from "../stores";
import { useDebounce } from "@/hooks/useDebounce";

const PAGE_SIZE = 10;

export function useAlertsList() {
  const [page, setPage] = useState(1);
  const searchValue = useAlertsFilterStore((s) => s.searchValue);
  const alertTypeFilter = useAlertsFilterStore((s) => s.alertTypeFilter);
  const frequencyFilter = useAlertsFilterStore((s) => s.frequencyFilter);
  const debouncedSearch = useDebounce(searchValue, 500);

  const [prevSearch, setPrevSearch] = useState(debouncedSearch);
  if (debouncedSearch !== prevSearch) {
    setPrevSearch(debouncedSearch);
    setPage(1);
  }

  const query = useQuery({
    queryKey: [
      "alerts",
      {
        page,
        search: debouncedSearch,
        alertType: alertTypeFilter,
        frequency: frequencyFilter,
      },
    ],
    queryFn: () =>
      alertsRepo.fetchList({
        limit: PAGE_SIZE,
        offset: (page - 1) * PAGE_SIZE,
        search: debouncedSearch || undefined,
        alert_type: alertTypeFilter ?? undefined,
        frequency: frequencyFilter ?? undefined,
      }),
    placeholderData: keepPreviousData,
  });

  const pageCount = query.data ? Math.ceil(query.data.count / PAGE_SIZE) : 0;

  return {
    alerts: query.data?.results ?? [],
    pageCount,
    page,
    setPage,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
  };
}
